
	import ModeloUpdate from '@/views/paginas/sigap/modelos/ModeloUpdate.vue';   
    import { Options   } from "vue-class-component"; 
    import {  Feriado } from "./Feriado";
	import $ from "jquery"   
    import   SiteUtils   from '@/assets/ts/aplicacao/site';
    import { PerfilConfig } from "@/core/config/PerfisConfig";
	  
    @Options({
        name: "FeriadoEdicao",
        components: {   },  
        emits: [  'update-feriado-alterado'],  
    }) 
    export default class FeriadoEdicao extends ModeloUpdate {
           
        created() {  
            this.campos =  Feriado.campos();   
        }
   
        get hasPermissao(   ): boolean {
            return SiteUtils.hasPermissao( [ PerfilConfig.Admin ,  PerfilConfig.ChefeSTE ] ,  this.perfis); 
        }

        public modeloAlterado(){   
            this.formulario = {}
            if(this.modelo){  
                this.service.getModel(this.modelo.id) 
                .then(response => {   
                    this.formulario =  JSON.parse(JSON.stringify( response ));  
                    this.formulario.escolaridade = this.formulario.escolaridade.id;   
                })
                .catch(error => {
                    this.formulario = { };  
                });  
            } 
        }
 
        public sucesso(){  
            this.$emit("update-feriado-alterado", null);     
            $("[data-bs-dismiss='modal']").trigger({ type: "click" });
        }
        
    } 
